var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-test-id":"reports-show-page"}},[(_vm.$route.params.type === 'sms')?_c('SMS',{attrs:{"data-test-id":"reports-sms"}}):_vm._e(),(_vm.$route.params.type === 'calls')?_c('Calls',{attrs:{"data-test-id":"reports-others"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }